/**
 * Utility functions for email handling
 */

/**
 * Normalize email value to always be an array
 * Handles both single emails and comma-separated email strings
 */
export const normalizeEmailToArray = (email: string | string[] | undefined): string[] => {
  if (!email) return [];
  if (Array.isArray(email)) return email;

  // If it's a string that contains commas, split it
  if (typeof email === 'string' && email.includes(',')) {
    return email
      .split(',')
      .map(e => e.trim())
      .filter(e => e);
  }

  return [email];
};

/**
 * Normalize email value from array to comma-separated string
 * For backend compatibility: always return a string with emails separated by commas
 */
export const normalizeEmailFromArray = (emails: string[]): string => {
  if (emails.length === 0) return '';
  return emails.join(', ');
};

/**
 * Validate email format
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validate array of emails
 */
export const validateEmails = (emails: string[]): boolean => {
  if (emails.length === 0) return false;
  return emails.every(email => isValidEmail(email));
};

/**
 * Join emails for display or API
 */
export const joinEmails = (emails: string | string[]): string => {
  if (Array.isArray(emails)) {
    return emails.join(', ');
  }
  return emails;
};
